
  // IMPORTANT: This file was generated by tools/build.js
  // If you edit it, your changes will be overwritten once dev server restarts
  export default {
  "CONFIG_ID": "bnpp:production",
  "CUSTOM_APP_NAME": "Upsun BNPP",
  "CUSTOM_ASSETS_URL": false,
  "CUSTOM_BLACKFIRE_CARD_LANGUAGE": [
    "php",
    "python"
  ],
  "CUSTOM_BRANDING_MESSAGE": false,
  "CUSTOM_CLI_COMMAND": "upsun-bnpp",
  "CUSTOM_CONFIG_DIR_NAME": ".upsun",
  "CUSTOM_CONSOLE_TITLE": false,
  "CUSTOM_CSP": false,
  "CUSTOM_DEFAULT_BRANCH": "main",
  "CUSTOM_FEDERATED_AUTH_PROVIDERS": false,
  "CUSTOM_FOOTER_TEXT": false,
  "CUSTOM_LOGO_HEIGHT": 34,
  "CUSTOM_PROFILING_LANGUAGE": [
    "php",
    "python",
    "golang",
    "java",
    "node",
    "ruby",
    "rust"
  ],
  "CUSTOM_THEME": false,
  "CUSTOM_WINDOW_TITLE": "Upsun BNPP",
  "CUSTOM_FULL_PAGE_REDIRECT": false,
  "CUSTOM_URL_BILLING": false,
  "CUSTOM_URL_CLI_DOWNLOAD": "https://cli.bnpp.platform.sh/installer",
  "CUSTOM_URL_DOCS": false,
  "CUSTOM_URL_DOCS_STATUS_CHECK": false,
  "CUSTOM_URL_PROJECT_CREATION": false,
  "CUSTOM_URL_SUBSCRIPTION_DELETE_REDIRECT": false,
  "CUSTOM_URL_SUBSCRIPTION_UPGRADE": false,
  "CUSTOM_URL_SUPPORT": false,
  "ZENDESK_BASE_URL": "https://support.upsun.com/hc/en-us",
  "ZENDESK_CLOUD_TAG": "bnpp",
  "CUSTOM_URL_VENDOR_CONSOLE": false,
  "CUSTOM_ERROR_SUPPORT_URL": false,
  "ZENDESK_SUBMIT_TICKET_FORM_ID": "35294051960082",
  "ZENDESK_FEATURE_REQUEST_FORM_ID": "37982573191442",
  "ZENDESK_DELETE_ACCOUNT_FORM_ID": "37982218098962",
  "URL_ACCOUNTS": "https://accounts.platform.sh",
  "URL_ANNOUNCEMENTS": "https://platform.sh/product/announcements/index.json",
  "URL_API_PROXY": "https://api.bnpp.platform.sh",
  "URL_AUTH": "https://auth.bnpp.platform.sh",
  "URL_GITHUB": "https://api.github.com",
  "URL_GITLAB": "https://gitlab.com",
  "URL_LOGOUT": "https://auth.bnpp.platform.sh/auth/logout",
  "URL_REDIRECT_AFTER_LOGIN": false,
  "URL_REDIRECT_AFTER_LOGOUT": "https://login.microsoftonline.com/common/oauth2/v2.0/logout",
  "URL_REDIRECT_AUTH_USER": "https://console.bnpp.platform.sh",
  "URL_SIA": false,
  "URL_STATUS_API": "https://status.ewebhosting.upsun.com",
  "ID_API_CLIENT": "ui@bnpp",
  "ID_COOKIELAW": "8jqkqc",
  "ID_DRIFT_CHATBOT": false,
  "ID_PENDO": false,
  "ID_PENDO_AUTH": false,
  "ID_PLATFORM_TREE": false,
  "ID_RECAPTCHA": "",
  "ID_SENTRY_DNS": "https://7682ebc48eef70826bdca7ac9f08b505@o38989.ingest.us.sentry.io/4508160398852096",
  "ID_SENTRY_ORGANIZATION": "platformsh",
  "ID_SENTRY_PROJECT": "console",
  "DISABLE_ALL_PROJECTS": true,
  "ENABLE_ACCOUNT_SECURITY_ROUTE": false,
  "ENABLE_ADD_DOMAIN_SUPPORT": false,
  "ENABLE_ADD_PROJECT_USER_PRICING_AGREEMENT": true,
  "ENABLE_ANNOUNCEMENTS": true,
  "ENABLE_AUTOSCALING": true,
  "ENABLE_BACKUPS": true,
  "ENABLE_BILLING": true,
  "ENABLE_BILLING_ACCOUNTS_MENU": false,
  "ENABLE_BLACKFIRE_CARD": false,
  "ENABLE_CARBON_EMISSIONS_DASHBOARD": false,
  "ENABLE_CHANGE_USERNAME_EMAIL": false,
  "ENABLE_COMMAND_MENU": true,
  "ENABLE_COMMAND_MENU_DOCS": false,
  "ENABLE_CONFIG_DIFFS": true,
  "ENABLE_CONNECTED_ACCOUNTS_ROUTE": false,
  "ENABLE_CONTAINERS_RELATIONSHIPS_DETAILS": true,
  "ENABLE_CONTAINERS_SERVICE_LINKS": true,
  "ENABLE_CONTINUOUS_PROFILING_SELLABLE": false,
  "ENABLE_CREATE_ORGANIZATION": false,
  "ENABLE_CREATE_PROJECT": true,
  "ENABLE_CRONS": true,
  "ENABLE_CUSTOM_BANNER_MESSAGE": false,
  "ENABLE_CUSTOM_LEFT_PANEL": false,
  "ENABLE_DEPLOYMENT_STRATEGIES": true,
  "ENABLE_DISCLAIMER_GENERAL_SUPPORT": false,
  "ENABLE_EDIT_PLAN": false,
  "ENABLE_ENVIRONMENT_DOMAINS": true,
  "ENABLE_ENVIRONMENT_SOCKET": false,
  "ENABLE_FIRST_PROJECT_INCENTIVE": false,
  "ENABLE_FREE_TRIAL_DIALOG": false,
  "ENABLE_GREEN_DISCOUNT": false,
  "ENABLE_HIPAA_COMPLIANCE": false,
  "ENABLE_HTTP_METRICS": false,
  "ENABLE_IMAGES_LIFECYCLE_MANAGEMENT": false,
  "ENABLE_INTERNAL_SERVICE_METRICS": false,
  "ENABLE_LOCAL_DEPLOYMENT_TARGET": false,
  "ENABLE_MAINTENANCE_WINDOW": true,
  "ENABLE_MARKETING_CHECKBOX": true,
  "ENABLE_METRICS_EXPLORER": false,
  "ENABLE_MODAL_REDIRECTION_DOCS": false,
  "ENABLE_NOTIFICATION_SETTINGS": true,
  "ENABLE_OBJECT_STORAGE": true,
  "ENABLE_OBSERVABILITY_SUITE_INTEGRATIONS": true,
  "ENABLE_OBSERVABILITY_TABS": true,
  "ENABLE_OCI_DOCKER": false,
  "ENABLE_ORGANIZATION": true,
  "ENABLE_ORGANIZATION_PLANS_PERMISSION": true,
  "ENABLE_ORGANIZATION_TYPE_DISPLAY": true,
  "ENABLE_PLUGIN_APP": false,
  "ENABLE_PROFILING": false,
  "ENABLE_PROJECT_ACCESS_SELECT": false,
  "ENABLE_PROJECT_PROVISIONING_WIZARD": false,
  "ENABLE_PROJECT_SETUP_TIPS": false,
  "ENABLE_PROJECT_SETUP_WIZARD": true,
  "ENABLE_PROJECT_TRAFFIC_BLOCK": true,
  "ENABLE_PROVISIONING_CARD": false,
  "ENABLE_REACTIVATE_TRIAL": false,
  "ENABLE_REDUCED_WIZARD": false,
  "ENABLE_REDUX_DEVTOOLS": false,
  "ENABLE_REGISTRATION": false,
  "ENABLE_RESET_PROFILE_PASSWORD": true,
  "ENABLE_RESOURCE_ALLOCATION_PRICING": false,
  "ENABLE_RESOURCE_METRICS": true,
  "ENABLE_SECURITY_ENFORCEMENT_BANNER": false,
  "ENABLE_SENTRY": true,
  "ENABLE_SERVICE_TREE": true,
  "ENABLE_SERVICES_AUTOSCALING": false,
  "ENABLE_SETTINGS_RESOURCES": false,
  "ENABLE_SINGLE_STEP_SINGUP_FLOW": false,
  "ENABLE_SOURCE_REPOSITORY_TOOLTIP": false,
  "ENABLE_SSH_KEYS_API": true,
  "ENABLE_STAFF_TEST_MODE": true,
  "ENABLE_STRIPE": true,
  "ENABLE_SUPPORT_SELLABLE": false,
  "ENABLE_TERMS_AND_ACCEPTANCE_CHECKBOX": true,
  "ENABLE_TOTAL_RESOURCE_ALLOCATION_METRICS": true,
  "ENABLE_TRIAL_USAGE": false,
  "ENABLE_UNBRANDED_ILLUSTRATIONS": false,
  "ENABLE_USAGE_BASED_BILLING_PAGES": true,
  "ENABLE_VOUCHERS": false,
  "ENABLE_ZENDESK_LINKS": true,
  "FIXED_CUSTOM_CONSOLE_ID": false,
  "FIXED_CUSTOM_CONFIG_DIR_NAME": ".platform",
  "FIXED_ENABLE_GREEN_DISCOUNT": false,
  "FIXED_ENABLE_FREE_TRIAL_DIALOG": false,
  "FIXED_ENABLE_DEPLOYMENT_STRATEGIES": false,
  "FIXED_ENABLE_EDIT_PLAN": true,
  "FIXED_ENABLE_ORGANIZATION_PLANS_PERMISSION": true,
  "FIXED_ENABLE_PROJECT_ACCESS_SELECT": false,
  "FIXED_ENABLE_PROJECT_SETUP_TIPS": false,
  "FIXED_ENABLE_PROJECT_SETUP_WIZARD": true,
  "FIXED_ENABLE_PROJECT_TRAFFIC_BLOCK": true,
  "FIXED_ENABLE_USAGE_BASED_BILLING_PAGES": true,
  "FIXED_ENABLE_CONTINUOUS_PROFILING_SELLABLE": false,
  "FIXED_ENABLE_CUSTOM_BANNER_MESSAGE": false,
  "FIXED_ENABLE_REACTIVATE_TRIAL": false,
  "VERSION_NUMBER": "3.3.124"
}